export const ADD_DISCOUNT_CODE_REQUESTED = 'ADD_DISCOUNT_CODE_REQUESTED';
export const ADD_DISCOUNT_CODE_SUCCESS = 'ADD_DISCOUNT_CODE_SUCCESS';
export const ADD_DISCOUNT_CODE_FAILED = 'ADD_DISCOUNT_CODE_FAILED';

export const DISCOUNT_CODES_REQUESTED = 'DISCOUNT_CODES_REQUESTED';
export const DISCOUNT_CODES_SUCCESS = 'DISCOUNT_CODES_SUCCESS';
export const DISCOUNT_CODES_FAILED = 'DISCOUNT_CODES_FAILED';

export const DELETE_DISCOUNT_CODE_REQUESTED = 'DELETE_DISCOUNT_CODE_REQUESTED';
export const DELETE_DISCOUNT_CODE_SUCCESS = 'DELETE_DISCOUNT_CODE_SUCCESS';
export const DELETE_DISCOUNT_CODE_FAILED = 'DELTE_DISCOUNT_CODE_FAILED';
